import { temporaryToken } from '@/config/auth'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/cart.html',
    name: 'cart',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/cart.vue'),
    meta: {
      options: [
        {
          name: 'Cart',
          path: '/cart.html',
        },
      ],
    },
  },
  {
    path: '/',
    name: 'userCenter',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/userCenter.vue'),
    redirect: '/orders-campers.html',
    meta: {
      options: [
        {
          name: 'Personal Center',
          path: '/',
        },
      ],
    },
    children: [
      {
        path: '/orders-campers.html',
        name: 'campersOrder',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/campersOrder.vue'),
        meta: {
          options: [
            {
              name: 'My Campers Order',
              path: '/orders-campers.html',
            },
          ],
        },
      },
      {
        path: '/orders-accessories.html',
        name: 'accessoriesOrder',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/accessoriesOrder.vue'),
        meta: {
          options: [
            {
              name: 'My Accessories order',
              path: '/orders-accessories.html',
            },
          ],
        },
      },
      {
        path: '/order-details.html',
        name: 'orderDetails',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/orderDetails.vue'),
        meta: {
          options: [
            {
              name: 'OrderDetails',
              path: '/order-details.html',
            },
          ],
        },
      },
      {
        path: '/evaluation.html',
        name: 'evaluation',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/evaluation.vue'),
        meta: {
          options: [
            {
              name: 'Evaluation',
              path: '/evaluation.html',
            },
          ],
        },
      },
      {
        path: '/my-evaluations.html',
        name: 'myEvaluate',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/myEvaluate.vue'),
        meta: {
          options: [
            {
              name: 'myEvaluate',
              path: '/my-evaluations.html',
            },
          ],
        },
      },
      {
        path: '/after-sale.html',
        name: 'afterSale',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/afterSale.vue'),
        meta: {
          options: [
            {
              name: 'AfterSale',
              path: '/after-sale.html',
            },
          ],
        },
      },
      {
        path: '/submit-after-sales.html',
        name: 'submiAfterSales',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/submiAfterSales.vue'),
        meta: {
          options: [
            {
              name: 'submiAfterSales',
              path: '/submit-after-sales.html',
            },  
          ],
        },
      },
      {
        path: '/profile.html',
        name: 'myProfile',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/myProfile.vue'),
        meta: {
          options: [
            {
              name: 'My Profile',
              path: '/profile.html',
            },
          ],
        },
      },
      {
        path: '/addresses.html',
        name: 'myAddress',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/myAddress.vue'),
        meta: {
          options: [
            {
              name: 'My Address',
              path: '/addresses.html',
            },
          ],
        },
      },
      {
        path: '/change-password.html',
        name: 'changePassword',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/changePassword.vue'),
        meta: {
          options: [
            {
              name: 'Change password',
              path: '/change-password.html',
            },
          ],
        },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/users/',
  routes
})

router.beforeEach((to, from, next) => {
  const token = temporaryToken || localStorage.getItem('token')
  const requireAuth = ['/', '/cart.html', '/orders-campers.html', '/orders-accessories.html', '/order-details.html', '/evaluation.html', '/my-evaluations.html', '/after-sale.html', '/submit-after-sales.html', '/profile.html', '/change-password.html', '/addresses.html']

  if (requireAuth.includes(to.path)) {
    if (token) {
      next()
    } else {
      window.location.href = '/login'
    }
  } else {
    next()
  }
})

router.afterEach(() => {})

export default router
